import { useQuery } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';
import type { PlantWithDevices } from '@/shared/data-types';
import { plantsWithDevicesQueryOptions } from './plants.query-options';

/**
 * plantId → 발전소명 lookup 맵. **캐시는 발전소 목록(`PLANTS_WITH_DEVICES_QUERY_KEY`)과 공유**하고
 * `select` 로 파생만 다르게 본다(추가 요청 없음 — 같은 화면이 목록·맵을 동시에 써도 호출 1회).
 *
 * 용도: 발전소명을 스스로 들고 오지 못하는 응답의 보강. `GET /events` 는 `include=plants` 를 보내도
 * `included.plants` 가 비어 오는 경우가 있어(`Event.plantName` 이 빈 값) 알림 카드의 위치 줄이
 * "인버터 01" 만 남는다 → 이 맵으로 "발전소명 / 인버터 01" 을 복원한다.
 */
export function usePlantNameMapQuery() {
  const api = useApiAppLegacy();
  return useQuery({
    ...plantsWithDevicesQueryOptions(api),
    // 모듈 스코프 함수 — 렌더마다 새 참조를 넘기면 select 가 매번 재실행돼 Map 참조가 깨진다.
    select: toPlantNameMap,
  });
}

function toPlantNameMap(plants: PlantWithDevices[]): Map<string, string> {
  return new Map(plants.map((plant) => [plant.plantId, plant.plantName]));
}
